type Handler = (payload: never) => void;

export interface Emitter {
  on(event: string, handler: Handler): () => void;
  emit(event: string, payload: unknown): void;
  clear(): void;
}

/** A merchant handler that throws is reported, and never breaks the widget. */
export function createEmitter(): Emitter {
  const handlers = new Map<string, Set<Handler>>();
  return {
    on(event, handler) {
      let set = handlers.get(event);
      if (!set) handlers.set(event, (set = new Set()));
      set.add(handler);
      return () => {
        set.delete(handler);
      };
    },
    emit(event, payload) {
      handlers.get(event)?.forEach((handler) => {
        try {
          (handler as (payload: unknown) => void)(payload);
        } catch (error) {
          reportError(error);
        }
      });
    },
    clear() {
      handlers.clear();
    },
  };
}
